import { useMemo } from 'react';

import moment from 'moment';

import {
  MAX_DATE,
  OUTPUT_CUSTOMER_DATE_FORMAT,
} from 'components/modules/Insurance/Insurance.constants';

export const useMaxDate = ({ date }) => {
  const maxDate = useMemo(() => {
    if (!date) {
      return MAX_DATE;
    }

    const parsed = moment(date, OUTPUT_CUSTOMER_DATE_FORMAT);

    return parsed.toDate();
  }, [date]);

  return { maxDate };
};
